import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { APP_ROUTES } from "../../config/appRoutes";
import { useData } from "../../context/DataContext";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { getClientTheme } from "../../theme/clientTheme";

function AdoptionMain() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user_client_id, user = {} } = useData();
    const clientTheme = getClientTheme(user_client_id);
    const clientId = user_client_id;
    const [tab, setTab] = useState(0);

    const tabs = [
        {
            label: "Report",
            icon: <AssessmentIcon />,
            route: APP_ROUTES.ADOPTION.SUMMARYREPORT,
            show: true,
        },
        {
            label: "Details",
            icon: <HistoryIcon />,
            route: APP_ROUTES.ADOPTION.HISTORY,
            show: true,
        },
        {
            label: "Creation",
            icon: <AddCircleOutlineIcon />,
            route: APP_ROUTES.ADOPTION.CREATION,
            show: user.user_level_id !== 1 &&
                user.user_level_id !== 2 &&
                user.user_level_id !== 3,
        },
        {
            label: "Overall Summary",
            icon: <SummarizeIcon />,
            route: APP_ROUTES.ADOPTION.OVERALSUMMARY,
            show: true,
        },
    ].filter(tab => tab.show);

    const handleTabChange = (_, newValue) => {
        setTab(newValue);
        navigate(tabs[newValue].route);
    };

    const currentTab = tabs.findIndex(tab =>
        location.pathname.includes(tab.route)
    );

    const hideTabs =
        location.pathname.includes(APP_ROUTES.SOILREPORT.HISTORY_ROUTES.EDIT) ||
        location.pathname.includes(APP_ROUTES.SOILREPORT.HISTORY_ROUTES.VILLAGEEDIT);

    const tabSx = {
        color: clientId === 1 ? "success.main" : "#000",
        "&.Mui-selected": {
            color: clientId === 1 ? "success.main" : "#000",
        },
    };

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
            {!hideTabs && (
                <Tabs
                    value={currentTab === -1 ? 0 : currentTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    TabIndicatorProps={{
                        style: { backgroundColor: clientId === 1 ? "#2e7d32" : clientTheme.activeBg, },
                    }}
                >
                    {tabs.map((item, index) => (
                        <Tab
                            key={index}
                            label={item.label}
                            icon={item.icon}
                            iconPosition="start"
                            sx={tabSx}
                        />
                    ))}
                </Tabs>
            )}
            <Outlet />
        </Box>
    );
}

export default AdoptionMain;
